import React from "react";
import { Link } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";
import { useFeatureFlags } from "../contexts/FeatureFlagsContext";

export default function Footer() {
  const { isRouteEnabled } = useFeatureFlags();
  return (
    <footer className="nhsuk-footer pguh-footer" role="contentinfo">
      <div className="nhsuk-width-container">
        <div className="pguh-footer__grid">
          <div>
            <h2 className="pguh-footer__heading">
              Royal University Hospitals Trust
            </h2>
            <p className="nhsuk-body-s">
              Internal digital services for authorised staff and approved users.
            </p>
          </div>

          <nav aria-label="Legal and policy links">
            <h2 className="pguh-footer__heading">Policies</h2>
            <ul className="nhsuk-footer__list pguh-footer__links">
              {isRouteEnabled("/terms") && <li className="nhsuk-footer__list-item">
                <Link className="nhsuk-footer__list-item-link" to="/terms">Terms of service</Link>
              </li>}
              {isRouteEnabled("/privacy") && <li className="nhsuk-footer__list-item">
                <Link className="nhsuk-footer__list-item-link" to="/privacy">Privacy policy</Link>
              </li>}
              {isRouteEnabled("/gdpr") && <li className="nhsuk-footer__list-item">
                <Link className="nhsuk-footer__list-item-link" to="/gdpr">Data protection and GDPR</Link>
              </li>}
            </ul>
          </nav>
        </div>

        <div className="pguh-footer__meta">
          <div className="pguh-footer__meta-copy">
            <p className="nhsuk-body-s nhsuk-u-margin-bottom-0">
              © {new Date().getFullYear()} Royal University Hospitals Trust
            </p>
            <p className="nhsuk-body-s nhsuk-u-margin-bottom-0">
              Staff intranet · PGUH Services
            </p>
          </div>

          <ThemeToggle />
        </div>
      </div>
    </footer>
  );
}
